import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const AuditlogAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		tablename: yup.string().required().label("Tablename"),
		recordid: yup.number().required().label("Recordid"),
		action: yup.string().required().label("Action"),
		oldvalues: yup.string().nullable().label("Oldvalues"),
		newvalues: yup.string().nullable().label("Newvalues"),
		changedby: yup.number().nullable().label("Changedby"),
		changedbytype: yup.string().nullable().label("Changedbytype"),
		changedat: yup.string().nullable().label("Changedat"),
		ipaddress: yup.string().nullable().label("Ipaddress"),
		useragent: yup.string().nullable().label("Useragent")
	});
	
	//form default values
	const formDefaultValues = {
		tablename: '', 
		recordid: '', 
		action: '', 
		oldvalues: '', 
		newvalues: '', 
		changedby: '', 
		changedbytype: '', 
		changedat: "(getdate())", 
		ipaddress: '', 
		useragent: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/auditlog`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="AuditlogAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Auditlog"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Tablename *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="tablename"  onChange={formik.handleChange}  value={formik.values.tablename}   label="Tablename" type="text" placeholder="Enter Tablename"        className={inputClassName(formik?.errors?.tablename)} />
                                                <ErrorMessage name="tablename" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Recordid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="recordid"  onChange={formik.handleChange}  value={formik.values.recordid}   label="Recordid" type="number" placeholder="Enter Recordid"  min={0}  step="any"    className={inputClassName(formik?.errors?.recordid)} />
                                                <ErrorMessage name="recordid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Action *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="action"  onChange={formik.handleChange}  value={formik.values.action}   label="Action" type="text" placeholder="Enter Action"        className={inputClassName(formik?.errors?.action)} />
                                                <ErrorMessage name="action" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Oldvalues 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="oldvalues"  onChange={formik.handleChange}  value={formik.values.oldvalues}   label="Oldvalues" type="text" placeholder="Enter Oldvalues"        className={inputClassName(formik?.errors?.oldvalues)} />
                                                <ErrorMessage name="oldvalues" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Newvalues 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="newvalues"  onChange={formik.handleChange}  value={formik.values.newvalues}   label="Newvalues" type="text" placeholder="Enter Newvalues"        className={inputClassName(formik?.errors?.newvalues)} />
                                                <ErrorMessage name="newvalues" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Changedby 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="changedby"  onChange={formik.handleChange}  value={formik.values.changedby}   label="Changedby" type="number" placeholder="Enter Changedby"  min={0}  step="any"    className={inputClassName(formik?.errors?.changedby)} />
                                                <ErrorMessage name="changedby" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Changedbytype 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="changedbytype"  onChange={formik.handleChange}  value={formik.values.changedbytype}   label="Changedbytype" type="text" placeholder="Enter Changedbytype"        className={inputClassName(formik?.errors?.changedbytype)} />
                                                <ErrorMessage name="changedbytype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Changedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="changedat" value={formik.values.changedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.changedat)}        />
                                                <ErrorMessage name="changedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Ipaddress 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ipaddress"  onChange={formik.handleChange}  value={formik.values.ipaddress}   label="Ipaddress" type="text" placeholder="Enter Ipaddress"        className={inputClassName(formik?.errors?.ipaddress)} />
                                                <ErrorMessage name="ipaddress" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Useragent 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="useragent"  onChange={formik.handleChange}  value={formik.values.useragent}   label="Useragent" type="text" placeholder="Enter Useragent"        className={inputClassName(formik?.errors?.useragent)} />
                                                <ErrorMessage name="useragent" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
AuditlogAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'auditlog',
	apiPath: 'auditlog/add',
	routeName: 'auditlogadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default AuditlogAddPage;
